import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {BookingService} from '../../services/booking.service';
import {Reservation} from '../../plugin-booking/model/reservation';

@Component({
    selector: 'app-my-bookings',
    templateUrl: 'my-bookings.component.html',
    styleUrls: ['./my-bookings.component.css'],
    standalone: false
})
export class MyBookingsComponent implements OnInit {
  myReservations: Reservation[] = [];

  @Output()
  contentAvailable = new EventEmitter<boolean>();

  constructor(private bookingService: BookingService) {}

  ngOnInit() {
    this.bookingService
      .getReservationsPage(true, 0, 5, 'startTime', 'ASC')
      .subscribe((data: any) => {
        this.myReservations = data.content;
        this.contentAvailable.emit(this.myReservations.length > 0);
      });
  }
}
